'use client';

import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

import { useTrackingUserParamsStore } from '../store';

enum TrackingParamKey {
  AppId = 'app_id',
  PwaId = 'pwa_id',
}

export const useTrackAppOrPwaId = () => {
  const searchParams = useSearchParams();
  const router = useRouter();

  const queryAppId = searchParams.get(TrackingParamKey.AppId) ?? undefined;
  const queryPwaId = searchParams.get(TrackingParamKey.PwaId) ?? undefined;

  const { app_id, pwa_id, setTrackingUserParams } = useTrackingUserParamsStore(
    (state) => ({
      app_id: state.app_id,
      pwa_id: state.pwa_id,
      setTrackingUserParams: state.setTrackingUserParams,
    })
  );

  useEffect(() => {
    let shouldClean = false;

    if (queryAppId && !app_id) {
      setTrackingUserParams({ app_id: queryAppId });
      shouldClean = true;
    }

    if (queryPwaId && !pwa_id) {
      setTrackingUserParams({ pwa_id: queryPwaId });
      shouldClean = true;
    }

    if (shouldClean) {
      const url = new URL(window.location.href);
      url.searchParams.delete(TrackingParamKey.AppId);
      url.searchParams.delete(TrackingParamKey.PwaId);

      router.replace(url.pathname + url.search);
    }
  }, [queryAppId, queryPwaId, app_id, pwa_id, setTrackingUserParams, router]);

  return { app_id, pwa_id };
};
